import "./index.less";
import { getCountry, getAwsS3Data } from '@utils/api.js'
import { uploadToS3 } from '@utils/index.js'

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // Interested Products - 选择其他选项并输入自定义文本时，则自动填充到复选框值中
    const jpForm = document.querySelector('.jp-offer-form');
    const chooseLabel = document.querySelector('.jp-offer-form #chooseLabel');

    //文件上传
    // 图片上传
    var s3keys = [];
    async function handleImageUpload(e) {

      const that = this;
      const files = e.target.files;
      if (!files.length) return;
      const file = files[0];
      // 检查文件类型
      const allowedTypes = [
        'application/pdf',
        'application/msword', // .doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/vnd.ms-excel', // .xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'text/plain' // .txt
      ];
      if (!allowedTypes.includes(file.type)) {
        const upload_format_error = document.querySelector('.jp-offer-form').getAttribute('data-upload_format_error');
        pushErrorMessage(upload_format_error);
        e.target.value = null;
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        const upload_exceed_error = document.querySelector('.jp-offer-form').getAttribute('data-upload_exceed_error');
        pushErrorMessage(upload_exceed_error);
        e.target.value = null;
        return;
      }

      // let type = file.name.split(".");
      // type = type[type.length - 1].toLowerCase();
      const info = await getAwsS3Data();
      chooseLabel.classList.add('loading');
      uploadToS3({ file, filename: `jp-offer/${file.name}` }, info.data)
        .then((s3) => {
          s3keys.push(s3.key);
          renderFileList(s3keys)
          jpForm.querySelector('.file-value').value = s3keys;
          chooseLabel.classList.remove('loading');
        }).finally(() => {
          e.target.value = null;
          chooseLabel.classList.remove('loading');
        })
    }

    // 图片删除
    async function handleImageClear(e, key) {
      // const that = this;
      e.preventDefault();
      e.stopPropagation();
      const info = await getAwsS3Data();
      let { access_key_id, secret_access_key, session_token, region, bucket } = info.data;
      let s3Client = new window.AWS.S3({ accessKeyId: access_key_id, secretAccessKey: secret_access_key, sessionToken: session_token, region });
      await s3Client.deleteObject({
        Bucket: bucket,
        Key: key
      })
    }

    const fileInput = document.getElementById('fileInput');
    const fileList = document.getElementById('fileList');
    let selectedFiles = [];

    // 模拟后端返回的文件ID（上传后会有真实ID）
    // 这里先用前端生成唯一ID占位
    const genTempId = () => '_' + Math.random().toString(36).substr(2, 9);

    // 文件选择
    fileInput.addEventListener('change', (e) => {
      handleImageUpload(e);
      const files = Array.from(e.target.files);
      if (selectedFiles.length + files.length > 3) {
        const upload_more_error = document.querySelector('.jp-offer-form').getAttribute('data-upload_more_error');
        pushErrorMessage(upload_more_error);
        pushErrorMessage('最大3ファイルまでアップロード可能です。');
        e.target.value = null;
        return;
      }

      files.forEach(file => {
        if (!selectedFiles.find(f => f.name === file.name)) {
          selectedFiles.push({
            id: genTempId(),
            file
          });
        }
      });

      updateUploadButtonState(); // 每次添加文件后更新按钮状态
    });

    // 渲染文件列表
    function renderFileList(s3keys) {
      fileList.innerHTML = '';
      // 把 s3keys 写回到 selectedFiles 对应项中
      selectedFiles.forEach((item, index) => {
        item.s3 = s3keys[index] || ''; // 没有对应 key 时为空字符串
      });

      selectedFiles.forEach(({ file, id, s3 }, index) => {
        const item = document.createElement('div');
        item.className = 'file-item';
        item.innerHTML = `
          <span>${file.name}</span>
          <button data-index="${index}" data-id="${id}" data-s3="${s3}"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M8 6h1.452V4.127c0-.245.084-.444.251-.595.168-.152.388-.228.662-.228h3.27c.274 0 .494.076.662.228.167.151.25.35.25.595V6H16V4.04c0-.63-.202-1.128-.607-1.493-.405-.365-.958-.547-1.658-.547h-3.47c-.7 0-1.253.182-1.658.547C8.202 2.912 8 3.409 8 4.039V6zM3.697 7h16.615a.63.63 0 00.488-.224.77.77 0 00.2-.531.743.743 0 00-.205-.526.641.641 0 00-.483-.219H3.697a.65.65 0 00-.488.224.74.74 0 00-.209.521c0 .205.07.382.21.531A.65.65 0 003.696 7zm4.268 15h8.579c.667 0 1.21-.196 1.628-.587.417-.39.642-.916.673-1.576L19.5 7h-1.506l-.627 12.68a.958.958 0 01-.29.675.945.945 0 01-.683.26H8.096a.924.924 0 01-.673-.265.964.964 0 01-.29-.67L6.469 7H5l.664 12.846c.031.66.254 1.184.67 1.572.414.388.958.582 1.631.582zm2.435-3c.18 0 .326-.052.436-.155a.526.526 0 00.164-.4l-.3-9.399a.505.505 0 00-.17-.395.623.623 0 00-.43-.151.625.625 0 00-.44.155.49.49 0 00-.16.4l.29 9.39c.007.169.065.304.175.404.11.1.255.151.435.151zm3.704 0c.175 0 .318-.05.428-.15.11-.101.169-.236.175-.406L15 9.056a.496.496 0 00-.155-.4.627.627 0 00-.448-.156.611.611 0 00-.428.15.552.552 0 00-.175.406l-.292 9.388a.496.496 0 00.155.4c.11.104.26.156.448.156z" fill="#666" fill-rule="nonzero"/></g></svg></button>
        `;
        fileList.appendChild(item);
      });

      // 删除事件
      document.querySelectorAll('.file-item button').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          const clickedBtn = e.currentTarget; // ✅ 稳定地指向绑定的 button
          const index = Number(clickedBtn.dataset.index);
          const key = clickedBtn.dataset.s3;
          handleImageClear(e, key)
          selectedFiles.splice(index, 1);
          s3keys.splice(index, 1);
          renderFileList(s3keys);
          jpForm.querySelector('.file-value').value = s3keys;
          updateUploadButtonState(); // 删除文件后重新启用按钮
        });
      });
    }

    // 更新上传按钮状态
    function updateUploadButtonState() {
      const uploadBtn = document.querySelector('.choose-btn'); // 你的上传按钮类名
      if (!uploadBtn) return;
      if (selectedFiles.length >= 3) {
        uploadBtn.disabled = true;
        uploadBtn.classList.add('disabled'); // 可选样式控制置灰
      } else {
        uploadBtn.disabled = false;
        uploadBtn.classList.remove('disabled');
      }
    }

    function toOffer(data) {
      if (data.response && data.response.code === 200) {
        const msg = document.querySelector('.jp-offer-form jds-button')?.dataset.success || data.response.message;
        pushSuccessMessage(msg);
        // 埋点
        const button_name= document.querySelector('.jp-offer-form jds-button').textContent.trim()
        gaPushDataLayer('form_user_clicks', {
          module: 'jp-offer-form',
          button_name: button_name
        })
      }

    }
    window.toOffer = toOffer

  })
})();